import styled from 'styled-components';
import Theme from '@adsk/alloy-react-theme';

export const StyledModalBody = styled.div`
  font-family: 'Artifakt Element';
  margin-bottom: 40px;
`;

export const SubheadingContainer = styled.p`
  color: ${Theme.colors.charcoal700};
  font-size: 14px;
`;

export const Subheading = styled.b`
  color: ${Theme.colors.charcoal900};
  font-size: 14px;
  font-weight: bold;
  display: block;
  margin: 4px 0;
`;

export const DescriptionMessage = styled.p`
  color: ${Theme.colors.charcoal900};
  font-size: 14px;
  margin: 14px 0;
`;
